import { useInView } from 'react-intersection-observer'
import CountUp from 'react-countup'

const AnimatedCounter = ({ end = 0, duration = 2 }) => {
  const { ref, inView } = useInView({ triggerOnce: true })

  return <span ref={ref}>{inView ? <CountUp end={end} duration={duration} /> : 0}</span>
}

export default AnimatedCounter
